import { ShoppingCartOutlined } from "@mui/icons-material";
import { Badge, Button } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { getUserCart } from "../utility/httpActions/cartActions";
import useAuthentication from "../hooks/useAuthentication";

const CartButton = () => {
  const { isLoggedIn } = useAuthentication();
  const { data } = useQuery({
    queryKey: ["userCart", isLoggedIn],
    queryFn: () => getUserCart(isLoggedIn),
  });

  const { cartItems } = data || {};
  const totalQuantityInCart = cartItems?.reduce((accumulator, item) => {
    return accumulator + item.quantity;
  }, 0);
  return (
    <Button
      to="/my-cart"
      component={Link}
      startIcon={
        <Badge
          badgeContent={totalQuantityInCart}
          sx={{
            "& .MuiBadge-badge": {
              bgcolor: "#046287",
              color: "white",
              fontSize: 10,
              minWidth: 16,
              height: 16,
              padding: "0 4px",
            },
          }}
        >
          <ShoppingCartOutlined
            sx={{ width: 24, height: 24, color: "#046287" }}
          />
        </Badge>
      }
    />
  );
};

export default CartButton;
